/**
 * chat_widget/src/widget/ui/Footer.tsx
 */

import type { FormActiveType } from "../types/formTypes";
import { buttonLang, inputLang } from "../utils/formatterLang";

export default function Footer({
  input,
  setInput,
  lang,
  onSend,
  loading,
  formActive,
  selectedCar,
}: {
  input: string;
  setInput: (text: string) => void;
  lang: string;
  onSend: () => void;
  loading: boolean;
  formActive: FormActiveType | null;
  selectedCar: boolean;
}) {
  return (
    <div className="vcw-footer">
      <div className="vcw-footer-input-container">
        <textarea
          className="vcw-input textarea"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={
            selectedCar
              ? "Posez une question sur ce véhicule.."
              : inputLang(lang)
          }
          rows={1}
          disabled={loading || formActive !== null}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
        />
        <button
          className="vcw-send"
          onClick={loading || formActive ? () => {} : () => onSend()}
          disabled={loading || formActive !== null}
        >
          {buttonLang(lang)}
        </button>
      </div>

      <div
        className="vcw-footer-mention"
        onClick={() => window.open("https://weespots.ai/")}
      >
        Propulsé par <span className="">Weespots AI</span>
      </div>
    </div>
  );
}
